import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import GiphyAPI from './GiphyAPI.react';
import GiphyContainer from '../giphy/GiphyContainer.react';
import SearchBar from './SearchBar.react';

class Giphy extends React.Component {
	static displayName = 'Giphy';

	static defaultProps = {
	  apiKey: 'dc6zaTOxFJmzC',
	  keyword: 'cat',
	};

	constructor(props) {
	  super(props);
	  this.api = new GiphyAPI();

	  const gifs = [];

	  this.state = {
	    imageSrc: '',
	    gifs,
	    term: 'trending',
	    trendingGifs: [],
	    sendGif: '',
	  };
	}

	handleTermChange = (term) => {
	  const self = this;
	  if (term.length < 2) {
	    self.setState({ gifs: self.state.trendingGifs, term: 'trending' });
	  } else if (term && term.length > 1) {
	    this.api.getSearch(term, (response) => {
	      self.setState({ gifs: response });
	      self.setState({ term });
	    });
	  }
	};

	handleGifPress = (sendGif) => {
	  this.props.addGif(sendGif);
	};

	loadImage = () => {
	  const self = this;
	  this.api.getTrending((response) => {
	    self.setState({ gifs: response, trendingGifs: response });
	  });
	};


	componentDidMount() {
	  this.loadImage();
	}

	render() {
	  let classNames = 'giphy-container pas';
	  if (this.props.isOpen) {
	    classNames += ' is-active';
	  }

	  return (
  <div className={classNames}>
    <div>
      <div className="giphy-close" onClick={this.props.toggleGiphyPanel}>&#10005;</div>
      <GiphyContainer
        term={this.state.term}
        onGifPress={this.handleGifPress}
        isOpen={this.props.isOpen}
        gifs={this.state.gifs}
      />
      <SearchBar onTermChange={this.handleTermChange} />
    </div>
  </div>
	  );
	}
}

module.exports = Giphy;
